export const environment = {
	production: true,

	oidc: {
		clientId: "0oabn2pnmabWHfv620x7",
		issuer: "https://crsoftware.oktapreview.com/oauth2/ausbmp4rt1eQiTMJF0x7",
		redirectUri: "/callback",
		scopes: ["openid", "profile", "email"],
		pkce: true,
	},
	userName: "",
};
